import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-duotone',
	templateUrl:'./FontAwesomeDuotonePluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeDuotonePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeDuotonePluginCompPage
{
	mdContent_927 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5pro.FontAwesomeDuotone;
\`\`\``;
	mdContent_928 = `\`\`\`java
FontAwesomeDuotone()
\`\`\``;
	mdContent_929 = `\`\`\`java
var icon = new FontAwesomeDuotone<>()
    .setStyle(FontAwesome5ProStyles.Duotone)
    .setIcon(FontAwesome5ProIcons.calendar)
    .primaryColour("#1976D2")
    .secondaryColour("#BBDEFB")
    .setSize(FontAwesomeSizes.$3x);
\`\`\``;
}
